import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "@/auth/AuthContext";
import RequireAuth from "@/auth/RequireAuth";
import MerchantLayout from "@/layout/MerchantLayout";
import HomePage from "@/pages/HomePage";
import LoginPage from "@/pages/LoginPage";
import PaymentOrdersPage from "@/pages/PaymentOrdersPage";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route element={<RequireAuth />}>
            <Route element={<MerchantLayout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/orders/payment" element={<PaymentOrdersPage />} />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
